import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import './assets/styles/global.css';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import CartDrawer from './components/cart/CartDrawer';
import CheckoutDrawer from './components/cart/CheckoutDrawer'; // ← NEW
import ProductsListPage from './pages/ProductsListPage';
import ProductPage from './pages/ProductPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import OrderDetailPage from './pages/OrderDetailPage';
import AdminDashboard from './pages/AdminDashboard';
import NotFoundPage from './pages/NotFoundPage';
import AdminLoginPage from './pages/AdminLoginPage';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import PrivacyPolicy from './pages/privacy-policy';
import TermsOfService from './pages/TermsOfService';
import ReturnPolicy from './pages/ReturnPolicy';
import ContactUs from "./pages/contactUs";

import BottomNavBar from './Bottomnavbar';
import ScrollToTop from './components/ScrollToTop';
import VedonciaInternationalBlog from './pages/Vedonciainternationalblog';
import VedonciaInternationalBlogDetail from "./pages/Vedonciainternationalblogdetail";
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-container"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};


const PublicOnlyRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : children;
};

function AppContent() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <CartDrawer />
      <CheckoutDrawer /> {/* ← Global checkout drawer, handles auth + checkout */}
      <main>
        <Routes>
          <Route path="/admin-login" element={<AdminLoginPage />} />
          <Route path="/admin-dashboard" element={
            <ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>
          } />

          <Route path="/" element={<ProductsListPage />} />
          <Route path="/product/:slug" element={<ProductPage />} />
          <Route path="/cart" element={<CartPage />} />

          {/* ← Checkout is now open to all — CheckoutDrawer handles auth inline */}
          <Route path="/checkout" element={<CheckoutPage />} />

          <Route path="/login" element={
            <PublicOnlyRoute><LoginPage /></PublicOnlyRoute>
          } />
          <Route path="/register" element={
            <PublicOnlyRoute><RegisterPage /></PublicOnlyRoute>
          } />

          <Route path="/dashboard" element={
            <PrivateRoute><DashboardPage /></PrivateRoute>
          } />
          <Route path="/orders/:orderId" element={
            <PrivateRoute><OrderDetailPage /></PrivateRoute>
          } />

          <Route path="/admin/*" element={
            <ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>
          } />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/returns" element={<ReturnPolicy />} />
          <Route path="/contactUs" element={<ContactUs />} />
          <Route path="/vedoncia-international-blog" element={<VedonciaInternationalBlog />} />
          <Route path="/blog/:id" element={<VedonciaInternationalBlogDetail />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <Footer />
        
        <BottomNavBar/>
    </Router>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <AppContent />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                fontFamily: 'DM Sans, sans-serif',
                borderRadius: '12px',
                padding: '14px 18px',
                fontSize: '0.9rem',
              },
              success: {
                style: { background: '#f0fdf4', color: '#14532d', border: '1px solid #bbf7d0' },
                iconTheme: { primary: '#16a34a', secondary: '#fff' },
              },
              error: {
                style: { background: '#fef2f2', color: '#7f1d1d', border: '1px solid #fecaca' },
                iconTheme: { primary: '#dc2626', secondary: '#fff' },
              },
            }}
          />
        </CartProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;